import classNames from 'classnames';

import styles from './MiniLoader.module.scss';

export enum LoaderThemes {
  Primary = 'primary',
  White = 'white',
}

const MiniLoader = ({ className, theme = LoaderThemes.Primary }: { className?: string; theme?: LoaderThemes }) => {
  return (
    <div className={classNames(styles.lds_ring, styles[theme], className)}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default MiniLoader;
